import { render, staticRenderFns } from "./LiveReminderSignUp.vue?vue&type=template&id=162ebd26&scoped=true"
import script from "./LiveReminderSignUp.vue?vue&type=script&lang=js"
export * from "./LiveReminderSignUp.vue?vue&type=script&lang=js"
import style0 from "./LiveReminderSignUp.vue?vue&type=style&index=0&id=162ebd26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162ebd26",
  null
  
)

export default component.exports